import { Component, OnInit, inject } from "@angular/core";
import {
  UntypedFormControl,
  FormsModule,
  ReactiveFormsModule
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions
} from "@angular/material/dialog";
import { TicketStore } from "@app/services/store/ticket-store";
import { Ticket } from "@app/models/rest/ticket";
import { CdkScrollable } from "@angular/cdk/scrolling";
import { MatToolbar, MatToolbarRow } from "@angular/material/toolbar";
import {
  MatFormField,
  MatLabel,
  MatSuffix,
  MatError
} from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { TranslatePipe } from "@ngx-translate/core";
import { DialogHeaderComponent } from "@app/view/shared/dialog-header/dialog-header.component";

@Component({
  selector: "app-ticket-duration-dialog",
  templateUrl: "./ticket-duration-dialog.component.html",
  styleUrls: ["./ticket-duration-dialog.component.css"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    MatSuffix,
    MatError,
    MatButton,
    MatDialogActions,
    TranslatePipe,
    DialogHeaderComponent
  ]
})
export class TicketDurationDialogComponent implements OnInit {
  protected ticketStore = inject(TicketStore);
  protected dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<TicketDurationDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  durationControl: UntypedFormControl = new UntypedFormControl();

  cancel() {
    this.dialogRef.close(false);
  }

  ngOnInit() {
    this.durationControl.setValue(this.data?.ticket?.duration);
  }

  resetDuration() {
    let calculatedDuration = 0;
    this.data.ticket.visit.visitScheduleList.forEach((value) => {
      calculatedDuration += value.smv * value.quantity;
    });
    this.durationControl.setValue(calculatedDuration);
  }

  updateDuration() {
    this.ticketStore
      .loadSingle(this.data.ticket.id)
      .then((storedTicket: Ticket) => {
        storedTicket.duration = this.durationControl.value;
        this.ticketStore.update(storedTicket).subscribe((value) => {
          this.dialogRef.close();
        });
      });
  }
}
